export class SupplementaryEquipment {
  key: string;
  dictionaryKey: string;
  selected: boolean;
  identifier: string;
  parameter1DictionaryKey: string;
  parameter1Value: string;
}


export class SupplementaryEquipmentHandout {
  visitId: number;
  firstname: string;
  name: string;
  company: string;
  supplementaryEquipments: SupplementaryEquipment[] = [];
}
